import React from 'react'
import { Typography } from '@material-ui/core'
import SettingsIcon from '@material-ui/icons/Settings'
import { prismicText } from '../Global/CMSText'
import Link from '../Link/Link'
import { useAccountStyles } from './AccountStyles'
import { useMatomo } from '@datapunt/matomo-tracker-react'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'

export const InfoLink = ({ doc }) => {
  const classes = useAccountStyles()
  const { trackEvent } = useMatomo()
  const { t } = useTranslation()
  return (
    <div className={classes.infosLinkContainer}>
      <Link href={'/account/informations'}>
        <a
          data-testid={'go_to_info'}
          onClick={() =>
            trackEvent({
              category: 'user Information',
              action: `User go to his Informations`,
            })
          }
        >
          <Typography
            variant={'body2'}
            component={'span'}
            className={clsx(classes.infosLink, 'account__infos-link')}
          >
            {prismicText(doc?.data?.info_link, t('texts:account:info_link'))}
            <SettingsIcon />
          </Typography>
        </a>
      </Link>
    </div>
  )
}
